import { IPaginationParams } from '../../../../types';
import { useQuery } from 'react-query';
import {
  getAllDefenseDevicesByLicenseAsync,
  getAllDefenseDevicesByLicenseCountAsync,
} from '../../index';
import { IDefenseDeviceFilterProps } from '../../types';
import { getUserId } from '../../../../DefaultService';

const USER_ID = getUserId();

export const useAllDefenseDevicesByLicenseAsync = (
  pagination: IPaginationParams,
  filter: IDefenseDeviceFilterProps,
) =>
  useQuery([`defenseDevices${pagination.pageNumber}`, pagination, USER_ID], {
    keepPreviousData: true,
    staleTime: 1000 * 60,
    queryFn: () => getAllDefenseDevicesByLicenseAsync(pagination, filter),
  });

export const useAllDefenseDevicesByLicenseCountAsync = (
  pagination: IPaginationParams,
  filter: IDefenseDeviceFilterProps,
) =>
  useQuery(
    [`defenseDevicesCount${pagination.pageNumber}`, pagination, USER_ID],
    {
      keepPreviousData: true,
      staleTime: 1000 * 60,
      queryFn: () => getAllDefenseDevicesByLicenseCountAsync(filter),
    },
  );
